import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=04e44f8a&"
import script from "./create-user.vue?vue&type=script&lang=js&"
export * from "./create-user.vue?vue&type=script&lang=js&"
import style0 from "./create-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports